import React, { Component } from 'react';
import { message } from 'antd';
import MachineTimersAddView from '../views/MachineTimersAddView';
import { base } from '../../base';
import moment from 'moment';

class MachineTimersAddContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timer: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.timerId = this.props.timerId;
        this.timerRef = null;
    }

    componentDidMount() {
        if (this.timerId) {
            this.timerRef = base.syncState(`timers/${this.props.extraUser.companyid}/${this.timerId}`, {
                context: this,
                state: 'timer',
            });
        }
    }

    componentWillUnmount() {
        if (this.timerRef != null) {
            base.removeBinding(this.timerRef);
        }
    }

    handleSubmit(values) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;
        const timerId = this.props.timerId;

        if (timerId) {
            this.handleUpdate(values);
        } else {
            const { closeForm } = this.props;
            let date1 = values.service[0];
            let date2 = values.service[1];
            let duration = moment.duration(date2.diff(date1));
            base.push(`timers/${this.props.extraUser.companyid}/`, {
                data: {
                    author: extraUser.key,
                    machineid: machineId,
                    createdtime: (new Date()).getTime(),
                    name: values.name,
                    description: values.description,
                    startdate: values.service[0].format('YYYY-MM-DD'),
                    enddate: values.service[1].format('YYYY-MM-DD'),
                    daysleft: duration.asDays(),
                },
                then(err) {
                    if (!err) {
                        message.success('Timer Agregado Exitosamente');
                        closeForm();
                    }
                },
            });
        }
    }

    handleUpdate(values) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;
        const timerId = this.props.timerId;
        const { closeForm } = this.props;
        base.update(`timers/${this.props.extraUser.companyid}/${timerId}`, {
            data: {
                author: extraUser.key,
                machineid: machineId,
                createdtime: (new Date()).getTime(),
                name: values.name,
                description: values.description,
                startdate: values.service[0].format('YYYY-MM-DD'),
                enddate: values.service[1].format('YYYY-MM-DD'),
            },
            then(err) {
                if (!err) {
                    message.success('Timer Editado exitosamente');
                    closeForm();
                }
            },
        });
    }

    render() {
        return (
            <MachineTimersAddView
                timer={this.state.timer}
                openForm={this.props.openForm}
                onCancel={this.props.onCancel}
                closeForm={this.props.closeForm}
                handleSubmit={this.handleSubmit}
            />
        );
    }
}

export default MachineTimersAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineTimersAddContainer.js